import { createSelector, createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type Proposal } from '@/store/proposalsSlice'
import type { RootState } from '.'

export type Invoice = {
  id: string
  category: string
  recipient: string
  owneraddress: string
  number: string
  currency: string
  total: number
  date: string
  duedate: string
  description: string
  status: string
  transactionHash: string
  budgetid: string
}

export type Budget = {
  amount: number
  breakdown: number
  category: string
  currency: string
  description: string
  id: string
  invoices: Invoice[]
  proposal: Proposal
  proposalid: string
  totalBudget: number
  remaining: number
}

export type BudgetState = {
  budgets: Budget[]
}

const initialState: BudgetState = {} as BudgetState

export const budgetSlice = createSlice({
  name: 'budget',
  initialState,
  reducers: {
    setBudgets: (state, action: PayloadAction<BudgetState>) => {
      return action.payload
    },
    upsertBudget: (state, action: PayloadAction<Budget>) => {
      const { id } = action.payload
      const index = state.budgets.findIndex((budget) => budget.id === id)
      if (index >= 0) {
        state.budgets[index] = action.payload
      } else {
        state.budgets.push(action.payload)
      }
    },
    removeBudget: (state, action: PayloadAction<string>) => {
      state.budgets = state.budgets.filter((budget) => budget.id !== action.payload)
    },
  },
})

export const { setBudgets, upsertBudget, removeBudget } = budgetSlice.actions

export const selectAllBudgets = (state: RootState): BudgetState => {
  return state[budgetSlice.name]
}

export const selectBudgetById = createSelector(
  [selectAllBudgets, (_, id: string) => id],
  (allBudgets, id): Budget | undefined => {
    return allBudgets.budgets.find((budget) => budget.id === id)
  },
)
